import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ICalendarState, IEventMonth } from "@adage/ace-calendar";
import { IWACEvent, InputOption, ICalendarReduxState, transitionWidthPx } from "../classes";
import { connect } from "react-redux";

import Dropdown from '../components/desktop-dropdown';
import MonthDropdown from '../components/month-dropdown';
import AdaCheckbox from '../views/ada-checkbox';
import Exit from '../views/exit';
import CalendarMode from '../components/calendar-mode';
import DaysOfTheWeek from '../components/days-of-the-week';


import { MediaQueryProps } from 'react-responsive';
var MediaQuery: React.ComponentClass<MediaQueryProps> = require('react-responsive');


interface FiltersExternalProps {
}

interface StateToProps {
    evts: Array<IEventMonth<IWACEvent>>;
    isGrid: boolean;
}

interface FiltersDispatchToProps {
    swapToList: () => any;
    swapToGrid: () => any;
}

type FiltersProps = FiltersExternalProps & StateToProps;

const filters: React.SFC<FiltersProps> = (props) => {
    /**
     * Render
     */
    return (
        <header className={`cal-header ${(props.isGrid ? 'cal-grid' : 'cal-list')}`}>
            <nav className="cal-nav">
                <div className="cal-nav-inner">
                    <div className="cal-nav-filters">
                        <MonthDropdown />
                        <Dropdown filterKey="productionName" propertyToCompare="name" name="Performances" apiEndpoint="GetProductionsFilters" />
                    </div>
                    <div className="cal-nav-options">
                        <AdaCheckbox />
                        <CalendarMode />
                    </div>
                    <Exit />
                </div>
                {
                    props.isGrid ?
                        <MediaQuery query={`(min-width: ${transitionWidthPx}px)`}>
                            <DaysOfTheWeek />
                        </MediaQuery> : null
                }

            </nav>
        </header>
    );
}

function mapStateToProps(state: ICalendarReduxState, externalProps: FiltersExternalProps) {
    return {
        evts: state.calendarModel.events,
        isGrid: state.calendarModeModel.isGrid
    }
}

export default connect<StateToProps>(mapStateToProps)(filters);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/containers/filters.tsx